import { useState, useEffect } from 'react';
import SelectInput from '../Components/SelectInput';
import OpenandCloseModal from '../TradeCurrency/OpenandCloseModal';
import { Currencies } from '../Components/Currencies';
// import axios from 'axios';
// import { getToken } from '../utils';

export const Column = () => {
  const [itemClicked, setItemClicked] = useState({});
  const [amountInputs, setAmountInputs] = useState(1);
  const { handleOpenandCloseModal, openModal } = OpenandCloseModal();
  const { currencys } = Currencies();

  const handleChange = (e) => setAmountInputs(Number(e.target.value));

  const [rateType, setRateType] = useState('1');

  const headerTwoRow = [
    {
      header: (
        <div className='w-full flex flex-col  rounded'>
          <select
            name='rateType'
            id='rateType'
            value={rateType}
            onChange={(e) => setRateType(e.target.value)}
            className='bg-white border border-white outline-white'
          >
            <option value='' disabled>
              Select rate type
            </option>
            <option value='1'>Parallel</option>
            <option value='2'>CBN</option>
            <option value='3'>LV</option>
            <option value='4'>Custom</option>
            <option value='5'>Parity</option>
          </select>
        </div>
      ),
    },
    {
      header: (
        <div className='w-full flex flex-row max-w-[  rounded'>
          <SelectInput
            selectDropDownData={{
              optionString: 'dashboard',
              textColor: 'white',
              selectModalContent: itemClicked,
              handleOpenandCloseModal,
              open: 'currency',
            }}
          />
        </div>
      ),
    },
    {
      header: (
        <input
          type='number'
          onChange={handleChange}
          className='font-normal w-1/2 border-b-mc py-1 h-11 rounded text-center text-p-wh bg-transparent [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none focus:outline-none focus:ring focus:b-mc'
          placeholder={1 + ' ' + itemClicked.code}
        />
      ),
    },
    {
      header: '',
    },
    {
      header: '',
    },
    {
      header: '',
    },
  ];
  const headerRowOne = [
    'Currency',
    'Amount',
    '%24h Change',
    '24h Chart',
    'Action',
  ];

  const allCurrency = currencys?.map((currency) => ({
    id: currency?.id,
    name: currency?.name,
    flag: currency?.country?.flag,
    code: currency?.symbol,
  }));

  //initialising itemClicke
  useEffect(() => {
    if (allCurrency?.length && Object.keys(itemClicked).length === 0)
      setItemClicked(allCurrency[0]);
  }, [allCurrency, itemClicked]);

  return {
    headerTwoRow,
    itemClicked,
    setItemClicked,
    amountInputs,
    headerRowOne,
    handleOpenandCloseModal,
    openModal,
    allCurrency,
    rateType,
  };
};
